export {
  importFailures,
  importSummary,
} from "components/DentalMaster/intraoralFindingForm";

export const DENTAL_ADVICE_CATEGORIES = [
  "Preventive Advice & Maintenance",
  "Rest & Diet",
  "Oral Hygiene",
  "Activity",
  "Expected Symptoms",
  "Warning Signs",
  "Temporary Restoration",
  "Intervention Today",
];

export const PATIENT_HISTORY_MASTERS = [
  {
    key: "medical-history",
    label: "Medical History",
    emptyText: "No Medical History records found.",
    templateFile: "medical_history_template.xlsx",
    exportFile: "medical_history_export.xlsx",
  },
  {
    key: "drug-allergy",
    label: "Drug Allergy",
    emptyText: "No Drug Allergy records found.",
    templateFile: "drug_allergy_template.xlsx",
    exportFile: "drug_allergy_export.xlsx",
  },
  {
    key: "tobacco-use",
    label: "Tobacco Use",
    emptyText: "No Tobacco Use records found.",
    templateFile: "tobacco_use_template.xlsx",
    exportFile: "tobacco_use_export.xlsx",
  },
  {
    key: "alcohol-other-habits",
    label: "Alcohol & Other Habits",
    emptyText: "No Alcohol & Other Habits records found.",
    templateFile: "alcohol_other_habits_template.xlsx",
    exportFile: "alcohol_other_habits_export.xlsx",
  },
  {
    // Categorised: every record has one category (Category filter, column and field).
    key: "dental-advice",
    label: "Dental Advice / Advisory Templates",
    emptyText: "No Dental Advice / Advisory Templates records found.",
    templateFile: "dental_advice_template.xlsx",
    exportFile: "dental_advice_export.xlsx",
    categories: DENTAL_ADVICE_CATEGORIES,
  },
];

export const ALL_SPECIALITIES_LABEL = "All Specialities";

/** Same rule as the backend (and the Complaint Master's name pattern). */
export const NAME_PATTERN = /^[a-zA-Z0-9\s/\\&\-(),.']+$/;
export const NAME_MIN = 2;
export const NAME_MAX = 200;

/** Speciality filter values: "" = any, "all" = All Specialities, else an id. */
export const SPECIALITY_FILTER_ANY = "";
export const SPECIALITY_FILTER_ALL = "all";

export const STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const validateHistoryForm = ({
  name,
  speciality = [],
  allSpecialities = false,
  category = "",
  categories = null,
}) => {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return "Name is required";
  if (trimmed.length < NAME_MIN) return `Use at least ${NAME_MIN} characters`;
  if (trimmed.length > NAME_MAX) return `Use at most ${NAME_MAX} characters`;
  if (!NAME_PATTERN.test(trimmed)) {
    return "Only letters, numbers and - / & ( ) , . ' are allowed";
  }
  if (categories?.length) {
    if (!String(category ?? "").trim()) return "Category is required";
    if (!categories.includes(category)) return "Choose a category from the list";
  }
  if (allSpecialities && speciality.length > 0) {
    return `"${ALL_SPECIALITIES_LABEL}" cannot be combined with specific specialities`;
  }
  if (!allSpecialities && speciality.length === 0) {
    return `Select at least one speciality, or choose "${ALL_SPECIALITIES_LABEL}"`;
  }
  return "";
};

/**
 * Name, speciality and status (+ category on a categorised master): clinic and
 * source are set by the server.
 */
export const buildHistoryPayload = ({
  name,
  speciality = [],
  allSpecialities = false,
  isActive = true,
  category,
}) => ({
  name: String(name ?? "").trim(),
  ...(category !== undefined ? { category: String(category ?? "").trim() } : {}),
  speciality: allSpecialities
    ? []
    : speciality.map((item) => (typeof item === "string" ? item : item?._id)).filter(Boolean),
  allSpecialities: Boolean(allSpecialities),
  isActive: isActive !== false,
});

/** The list/export query; empty filters are left out. */
export const buildListParams = ({ page, perPage, search, speciality, status, category }) => ({
  ...(page ? { page } : {}),
  ...(perPage ? { perPage } : {}),
  ...(search ? { search } : {}),
  ...(category ? { category } : {}),
  ...(speciality ? { speciality } : {}),
  ...(status ? { status } : {}),
});

/** An existing record's speciality objects ([] = All Specialities). */
export const specialitiesOf = (record) =>
  (Array.isArray(record?.speciality) ? record.speciality : []).filter(
    (item) => item && typeof item === "object"
  );
